import { connect } from 'react-redux';
import React, { Component } from 'react';

var OrdersBox = class extends React.Component {render()

  {
    return this.props.children;
  }};


function mapStateToProps(state, props) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(OrdersBox);
